import React, { PropsWithChildren } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import moment from 'moment';
import classNames from 'classnames';
import PdfExportButton from '../Interest/Pdf/PdfExportButton';
import { useGetMomentResultsAreFetched } from '../../Hook/Interest/UseGetMomentResultsAreFetched';
import useGetSidebarIsOpened from '../../Hook/Interest/UseGetSidebarIsOpened';

type Props = PropsWithChildren<any> & {
    enablePdfExportButton: boolean;
    validator: boolean;
};

const Header: React.FC<Props> = ({ children, enablePdfExportButton: enablePdfExportButton, validator: validator }) => {
    const fetchedAt = useGetMomentResultsAreFetched();
    const sidebarOpened = useGetSidebarIsOpened();

    return (
        <div className={classNames('navbar-wrapper', { 'navbar-validator': validator })}>
            <Navbar className={classNames('justify-content-between', { 'navbar-fullscreen': !sidebarOpened || validator })}>
                {children}
                <Navbar.Text>
                    {fetchedAt !== undefined && <>Resultaat op {moment(fetchedAt).format('DD/MM/YYYY - H:mm')}</>}
                    {enablePdfExportButton && <PdfExportButton />}
                </Navbar.Text>
            </Navbar>
        </div>
    );
};

export default Header;
